import { lightTheme } from "@/customTheme"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <path
      fill={props.fill ?? lightTheme.colors.blackGray}
      fillRule="evenodd"
      d="M10 4H5a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-5h2v5a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V5a3 3 0 0 1 3-3h5v2Z"
      clipRule="evenodd"
    />
    <path
      fill={props.fill ?? lightTheme.colors.blackGray}
      fillRule="evenodd"
      d="M17 2a1 1 0 0 0-1 1v3h-3a1 1 0 1 0 0 2h3v3a1 1 0 1 0 2 0V8h3a1 1 0 1 0 0-2h-3V3a1 1 0 0 0-1-1Z"
      clipRule="evenodd"
    />
  </svg>
)
export default SvgComponent
